
import { ADMIN, CUSTOMER, CUSTOMER_EXPERIENCE, DEVELOPER, QUALITY_ASSURANCE } from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useCommentsPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole()

  return {
    canCreate: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CUSTOMER_EXPERIENCE),
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CUSTOMER_EXPERIENCE),
    canDelete: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CUSTOMER_EXPERIENCE),
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER)
  }
}
